import { TopicActionsSection } from '@communities/content-management/components';
import { StrikeConfigSection, StrikeLabelScoringSection, StrikeTopicsSection } from '@communities/content-management/components/StrikeConfigSection';
import { StrikePolicySection } from '@communities/content-management/components/StrikePolicySection';
import { EntityType, WorkflowType } from '@communities/content-management/domain';
import { withAppInsightsTracking } from '@core/logging/withAppInsightsTracking';
import { Section } from '@soteria/design-system-ve';

import { ActionsTab } from './ActionsTab';
import * as styles from './StrikeTab.css';

interface StrikeTabProps {
  communityId: string;
  isEntityAdmin: boolean;
}

/**
 * Strike tab component for community management.
 * Provides strike configuration, topics, policies, actions, and workflow management.
 */
function StrikeTabComponent({ communityId, isEntityAdmin }: StrikeTabProps) {
  return (
    <div className={styles.tabContainer}>
      {/* Strike Topic Settings Section */}
      <StrikeTopicsSection communityId={communityId} entityType={EntityType.COMMUNITY} isEntityAdmin={isEntityAdmin} sectionTitle="Strike Topic Settings" />

      {/* Strike Configuration Section (Rolling Window) */}
      <StrikeConfigSection communityId={communityId} isEntityAdmin={isEntityAdmin} />

      {/* Strike Labels Scoring Section */}
      <StrikeLabelScoringSection communityId={communityId} isEntityAdmin={isEntityAdmin} sectionTitle="Strike Labels Scoring" />

      {/* Strike Policies Section */}
      <StrikePolicySection communityId={communityId} isEntityAdmin={isEntityAdmin} />

      {/* Strike Actions Section */}
      <ActionsTab
        entityId={communityId}
        entityType={EntityType.COMMUNITY}
        isEntityAdmin={isEntityAdmin}
        sectionTitle="Strike Actions"
        workflowType={WorkflowType.STRIKE}
      />

      {/* Strike Workflow - Topic Actions */}
      <Section spacing="medium">
        <TopicActionsSection entityId={communityId} entityType={EntityType.COMMUNITY} isEntityAdmin={isEntityAdmin} workflowType={WorkflowType.STRIKE} />
      </Section>
    </div>
  );
}

export const StrikeTab = withAppInsightsTracking(StrikeTabComponent, 'StrikeTab');
